import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from "@angular/common/http"
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};
// let temp_project = "9ACE5C6E-7CEF-11EF-82D2-11D2CA82572B";
// let temp_project = "C23CD23E-8268-11EF-AC5E-5D4A603959EA";
// let temp_token = "e22f2c2268811847ede1067c4d622623b12018f8"

@Injectable({
  providedIn: 'root'
})

export class FacadeService {

  constructor(
    // public http: HttpClient
    ) {  }
  // Peticiones de usuario

  getApi_usage_data(http){
    let token = localStorage.getItem("text-inspector-django-token")
    const authttpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' , "Authorization":"Bearer "+ token})
    }
    return http.get(`${environment.url_api}/me/admin/api`, authttpOptions).toPromise()
  }

  verificarLoginConPerl(http, token_perl){
    console.log(token_perl);
    const authttpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json'})
    }
    return http.patch(`${environment.url_api}/token/`, {'token': token_perl} ,authttpOptions).toPromise()
  }

  getLoginUser(http){
    let token = localStorage.getItem("text-inspector-django-token")
    const authttpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' , "Authorization":"Bearer "+ token})
    }
    return http.get(`${environment.url_api}/me/`, authttpOptions).toPromise()
  }

  editUserinfo(http, data, token){
    const authttpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' , "Authorization":"Bearer "+ token})
    }
    return http.put(`${environment.url_api}/me/`,data, authttpOptions).toPromise()
  }

  deleteUserSubs(http){
    let token = localStorage.getItem("text-inspector-django-token")
    const authttpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' , "Authorization":"Bearer "+ token})
    }
    return http.delete(`${environment.url_api}/me/`, authttpOptions).toPromise()
  }

  //Core de Text
  deleteProject(http, data){
    let token = localStorage.getItem("text-inspector-django-token")
    const authttpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' , "Authorization":"Bearer "+ token})
    }
    if (sessionStorage.getItem('text_UID') == data.textuid){
      sessionStorage.removeItem('text_UID')
      sessionStorage.removeItem('id_project')
    }
    return http.delete(`${environment.url_api}/core/text/?project=${data.textuid}`, authttpOptions).toPromise()
  }

  createProject(http, data, token){
    if (token == "" || token == undefined){
      return http.post(`${environment.url_api}/core/text/`,data).toPromise()
    }else{
      const authttpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' , "Authorization":"Bearer "+ token})
      }
      return http.post(`${environment.url_api}/core/text/`,data, authttpOptions).toPromise()
    }
  }

  getInfoProyect(http, id_project){
    let token = localStorage.getItem("text-inspector-django-token")
    if (token == "" || token == undefined){
      return http.get(`${environment.url_api}/text/${id_project}`).toPromise()
    }else{
      const authttpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' , "Authorization":"Bearer "+ token})
      }
      return http.get(`${environment.url_api}/text/${id_project}`, authttpOptions).toPromise()
    }
  }

  getInfoUsers(http, token){
    const authttpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' , "Authorization":"Bearer "+ token})
    }
    return http.get(`${environment.url_api}/users/`, authttpOptions).toPromise()
  }

editInfoUser(http, id_sub, plan, extraPerms, token, org_size = null) {
  let extraQuery = "";
  if (extraPerms.length > 0) {
    extraQuery = extraPerms.map(p => `&extra_perms=${p}`).join("");
  }
  let url = `${environment.text_v1}/admin/changesub_NoCookie/${id_sub}?plan_id=${plan}${extraQuery}`;
  if (org_size != null){
    url = url + "&maximum_members="+ org_size;
  }
  if (!token) {
    return http.post(url, null).toPromise();
  }
  const authttpOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
      "Authorization": "Bearer " + token
    })
  };
  return http.post(url, null, authttpOptions).toPromise();
}




  getInfoUsersOrganization(http, token){
    const authttpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' , "Authorization":"Bearer "+ token})
    }
    return http.get(`${environment.url_api}/info/organization/`, authttpOptions).toPromise()
  }

  addMemerOrganization(http, email){
    let token = localStorage.getItem("text-inspector-django-token")
    const authttpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' , "Authorization":"Bearer "+ token})
    }
    const body = { email };
    return http.post(`${environment.url_api}/info/organization/`, body, authttpOptions).toPromise()
  }
  
  deleteMemerOrganization(http, id){
    let token = localStorage.getItem("text-inspector-django-token")
    const authttpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' , "Authorization":"Bearer "+ token})
    }
    return http.delete(`${environment.url_api}/info/organization/?eliminar_uid=${id}`, authttpOptions).toPromise()
  }
  
  UpdateTextofProyect(http, data){
    return http.put(`${environment.url_api}/core/text/`,data, httpOptions).toPromise()
  }

  UpdateNameofProyect(http, data){
    return http.patch(`${environment.url_api}/core/text/`,data, httpOptions).toPromise()
  }


  verificarStatusproject(http, project_id){
    return http.get(`${environment.url_api}/check/text/${project_id}`, httpOptions).toPromise()
    // return {"update": false}  
  }

  async getSummaryOfProject(http, project_id, user_cookie){
    let token = localStorage.getItem("text-inspector-django-token")
    if (token == "" || token == undefined){
      return http.get(`${environment.url_api}/summary/${project_id}`, httpOptions).toPromise()
    }else{
      const authttpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' , "Authorization":"Bearer "+ token})
      }
      return http.get(`${environment.url_api}/summary/${project_id}`, authttpOptions).toPromise()
    }
  }

  getSummary2OfProject(http, project_id, user_cookie){
    let token = localStorage.getItem("text-inspector-django-token")
    if (token == "" || token == undefined){
      return http.get(`${environment.url_api}/summaryp2/${project_id}`, httpOptions).toPromise()
    }else{
      const authttpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' , "Authorization":"Bearer "+ token})
      }
      return http.get(`${environment.url_api}/summaryp2/${project_id}`, authttpOptions).toPromise()
    }
  }

  getSummary3OfProject(http, project_id, user_cookie){
    let token = localStorage.getItem("text-inspector-django-token")
    if (token == "" || token == undefined){
      return http.get(`${environment.url_api}/summaryp3/${project_id}`, httpOptions).toPromise()
    }else{
      const authttpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' , "Authorization":"Bearer "+ token})
      }
      return http.get(`${environment.url_api}/summaryp3/${project_id}`, authttpOptions).toPromise()
    }
  }

    getSummary4OfProject(http, project_id, user_cookie){
    let token = localStorage.getItem("text-inspector-django-token")
    if (token == "" || token == undefined){
      return http.get(`${environment.url_api}/summaryp4/${project_id}`, httpOptions).toPromise()
    }else{
      const authttpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' , "Authorization":"Bearer "+ token})
      }
      return http.get(`${environment.url_api}/summaryp4/${project_id}`, authttpOptions).toPromise()
    }
  }

  getStatisticsOfProject(http, project_id, user_cookie){
    let token = localStorage.getItem("text-inspector-django-token")
    if (token == "" || token == undefined){
      return http.get(`${environment.url_api}/statistics/${project_id}`, httpOptions).toPromise()
    }else{
      const authttpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' , "Authorization":"Bearer "+ token})
      }
      return http.get(`${environment.url_api}/statistics/${project_id}`, authttpOptions).toPromise()
    }
  }

  getTaggerOfProject(http, project_id, user_cookie){
    let token = localStorage.getItem("text-inspector-django-token")
    if (token == "" || token == undefined){
      return http.get(`${environment.url_api}/tagger/${project_id}`, httpOptions).toPromise()
    }else{
      const authttpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' , "Authorization":"Bearer "+ token})
      }
      return http.get(`${environment.url_api}/tagger/${project_id}`, authttpOptions).toPromise()
    }
  }

  getLexicalDiversityOfProject(http, project_id, user_cookie){
    let token = localStorage.getItem("text-inspector-django-token")
    if (token == "" || token == undefined){
      return http.get(`${environment.url_api}/diversity/${project_id}`, httpOptions).toPromise()
    }else{
      const authttpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' , "Authorization":"Bearer "+ token})
      }
      return http.get(`${environment.url_api}/diversity/${project_id}`, authttpOptions).toPromise()
    }
  }

  getErrorsOfProject(http, project_id, user_cookie){
    let token = localStorage.getItem("text-inspector-django-token")
    if (token == "" || token == undefined){
      return http.get(`${environment.url_api}/errors/${project_id}`, httpOptions).toPromise()
    }else{
      const authttpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' , "Authorization":"Bearer "+ token})
      }
      return http.get(`${environment.url_api}/errors/${project_id}`, authttpOptions).toPromise()
    }
  }

  getErrorsOfProjectIZE(http, project_id, user_cookie){
    let token = localStorage.getItem("text-inspector-django-token")
    if (token == "" || token == undefined){
      return http.get(`${environment.url_api}/errors/${project_id}?update_ize=True`, httpOptions).toPromise()
    }else{
      const authttpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' , "Authorization":"Bearer "+ token})
      }
      return http.get(`${environment.url_api}/errors/${project_id}?update_ize=True`, authttpOptions).toPromise()
    }
  }

  getReadabilityOfProject(http, project_id, user_cookie){
    return http.get(`${environment.url_api}/readability/${project_id}`, httpOptions).toPromise()
  }

  getLexicalEVPOfProject(http, project_id, user_cookie){
    return http.get(`${environment.url_api}/lexical/evp/${project_id}`, httpOptions).toPromise()
  }

  getBncOfProject(http, project_id, user_cookie){
    return http.get(`${environment.url_api}/lexical/bnc/${project_id}`, httpOptions).toPromise()
  }

  getCocaOfProject(http, project_id, user_cookie){
    return http.get(`${environment.url_api}/lexical/coca/${project_id}`, httpOptions).toPromise()
  }

  getLexicalAWLOfProject(http, project_id, user_cookie){
    return http.get(`${environment.url_api}/lexical/awl/${project_id}`, httpOptions).toPromise()
  }

  getMetadiscourseOfProject(http, project_id, user_cookie){
    return http.get(`${environment.url_api}/metadiscourse/${project_id}`, httpOptions).toPromise()
  }

  getScoreCardOfProject(http, project_id, user_cookie){
    return http.get(`${environment.url_api}/scorecard/${project_id}`, httpOptions).toPromise()
  }

  getKVLOfProject(http, project_id, user_cookie,bucket, lenguaje){
    return http.get(`${environment.url_api}/lexical/kvl/${project_id}/${bucket}/${lenguaje}`, httpOptions).toPromise()
  }

    getAllApiDashboard(http, user_cookie, startDate = null){
    const authttpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' , "Authorization":"Bearer "+ user_cookie})
    }
    const query = startDate ? `?startDate=${encodeURIComponent(startDate)}` : '';
    return http.get(`${environment.url_api}/me/text/api${query}`, authttpOptions).toPromise()
  }

  getRangeApiDashboard(http, user_cookie, startDate, endDate){
    const authttpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' , "Authorization":"Bearer "+ user_cookie})
    }
    return http.get(`${environment.url_api}/me/text/api?startDate=${startDate}&endDate=${endDate}`, authttpOptions).toPromise()
  }

  getOneDayApiDashboard(http, user_cookie, startDate){
    const authttpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' , "Authorization":"Bearer "+ user_cookie})
    }
    return http.get(`${environment.url_api}/me/text/api?startDate=${startDate}&oneday=1`, authttpOptions).toPromise()
  }

  getAllApiDashboardUsage(http, user_cookie, text_UID, startDate = null){
    const authttpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' , "Authorization":"Bearer "+ user_cookie})
    }
    const queryParams = [`text_UID=${encodeURIComponent(text_UID)}`];
    if (startDate) queryParams.push(`startDate=${encodeURIComponent(startDate)}`);
    return http.options(`${environment.url_api}/me/text/api?${queryParams.join('&')}`, authttpOptions).toPromise()
  }

  getRangeApiDashboardUsage(http, user_cookie, startDate, endDate, text_UID){
    const authttpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' , "Authorization":"Bearer "+ user_cookie})
    }
    return http.options(`${environment.url_api}/me/text/api?startDate=${startDate}&endDate=${endDate}&text_UID=${text_UID}`, authttpOptions).toPromise()
  }

  getOneDayApiDashboardUsage(http, user_cookie, startDate, text_UID){
    const authttpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' , "Authorization":"Bearer "+ user_cookie})
    }
    return http.options(`${environment.url_api}/me/text/api?startDate=${startDate}&oneday=1&text_UID=${text_UID}`, authttpOptions).toPromise()
  }

  getAllprojects(http, user_cookie){
    const authttpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' , "Authorization":"Bearer "+ user_cookie})
    }
    return http.get(`${environment.url_api}/core/text/`, authttpOptions).toPromise()
  }

  getAllwordlists(http, user_cookie){
    const authttpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' , "Authorization":"Bearer "+ user_cookie})
    }
    return http.get(`${environment.url_api}/wordlists`, authttpOptions).toPromise()
  }

  createWordlist(http, user_cookie,data){
    const authttpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' , "Authorization":"Bearer "+ user_cookie})
    }
    return http.post(`${environment.url_api}/wordlists`,data, authttpOptions).toPromise()
  }

  editWordlist(http, user_cookie,data){
    const authttpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' , "Authorization":"Bearer "+ user_cookie})
    }
    return http.put(`${environment.url_api}/wordlists`,data, authttpOptions).toPromise()
  }

  deleteWordlist(http, user_cookie,data){
    const authttpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' , "Authorization":"Bearer "+ user_cookie})
    }
    return http.delete(`${environment.url_api}/wordlists?id=${data}`, authttpOptions).toPromise()
  }

  export_general(parsers_seleccionados,project_id){
    let params = ''
    let parsers = ["statistics=1&","errors=1&","diversity=1&","tagger=1&","taggedlexical-bc-es=1&","lexical-evp=1&","taggedlexical-coca=1&","taggedlexical-bnc=1&","academicwordlist=1&","metadiscourse=1&","scorecard=1&"]
    for (let index = 0; index < parsers.length; index++) {
      if (parsers_seleccionados[index]){
        params = params+parsers[index]
      }
      
    }
    window.open(`${environment.url_api}/export/${project_id}/general?${params}`,"_blank")
  }
  
  detail_export(parser,project_id){
    window.open(`${environment.url_api}/export/detailed/${project_id}/${parser}`,"_blank")
  }

  tagger_export(parser,project_id){
    window.open(`${environment.url_api}/export/tagged/${project_id}/${parser}`,"_blank")
  }

  getLexicalEVPOfWords(http, lenguaje, palabra){
    let token = localStorage.getItem("text-inspector-django-token")
    const authttpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' , "Authorization":"Bearer "+ token})
    }
    return http.get(`${environment.url_api}/search/evp?lenguaje=${lenguaje}&palabra=${palabra}`, authttpOptions).toPromise()
  }

  UpdateEVPWordCategory(http, project_id, data){
    let token = localStorage.getItem("text-inspector-django-token")
    const authttpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' , "Authorization":"Bearer "+ token})
    }
    return http.put(`${environment.url_api}/lexical/evp/${project_id}`, data, authttpOptions).toPromise()
  }

  UpdateStadisticsMetrics(http, project_id, data){
    let token = localStorage.getItem("text-inspector-django-token")
    if (token == "" || token == undefined){
      return http.put(`${environment.url_api}/statistics/${project_id}`, data, httpOptions).toPromise()
    }else{
      const authttpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' , "Authorization":"Bearer "+ token})
      }
      return http.put(`${environment.url_api}/statistics/${project_id}`, data, authttpOptions).toPromise()
    }
  }

  UpdateErrorsMetrics(http, project_id, data){
    let token = localStorage.getItem("text-inspector-django-token")
    if (token == "" || token == undefined){
      return http.put(`${environment.url_api}/errors/${project_id}`, data, httpOptions).toPromise()
    }else{
      const authttpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' , "Authorization":"Bearer "+ token})
      }
      return http.put(`${environment.url_api}/errors/${project_id}`, data, authttpOptions).toPromise()
    }
  }

  UpdateTaggerWordCategory(http, project_id, data){
    let token = localStorage.getItem("text-inspector-django-token")
    if (token == "" || token == undefined){
      return http.put(`${environment.url_api}/tagger/${project_id}`, data, httpOptions).toPromise()
    }else{
      const authttpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' , "Authorization":"Bearer "+ token})
      }
      return http.put(`${environment.url_api}/tagger/${project_id}`, data, authttpOptions).toPromise()
    }
  }

  UpdateAWLWordCategory(http, project_id, data){
    let token = localStorage.getItem("text-inspector-django-token")
    const authttpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' , "Authorization":"Bearer "+ token})
    }
    return http.put(`${environment.url_api}/lexical/awl/${project_id}`, data, authttpOptions).toPromise()
  }

  UpdateMetadiscourseWordCategory(http, project_id, data){
    let token = localStorage.getItem("text-inspector-django-token")
    const authttpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' , "Authorization":"Bearer "+ token})
    }
    return http.put(`${environment.url_api}/metadiscourse/${project_id}`, data, authttpOptions).toPromise()
  }

  cancelarMisub(http){
    let token = localStorage.getItem("text-inspector-django-token")
    const authttpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' , "Authorization":"Bearer "+ token})
    }
    return http.delete(`${environment.url_api}/me/`, authttpOptions).toPromise()
  }
}
